import React, { Fragment, useState } from "react";
import { ImageLoaderContainer, Slide } from "./SliderPreview.styled";
import PulsatingRing from "../../../../../Components/pulsating-ring/PulsatingRing";
import {
  getImageDimensions,
  isVideo
} from "../../../../SelfServiceCampaignCreation/Previews/utils";
import { AssetSlider } from "../../../../../Components/AssetSlider/AssetSlider";
import { SlideAsset } from "./SlideAsset";

const FALLBACK_IMAGES = [
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1735817845/tb-campaign-photos/pronto/assistant_prototype/17adca8fb4ef052fa201d09310b353c3.jpg",
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1735817845/tb-campaign-photos/pronto/assistant_prototype/17adca8fb4ef052fa201d09310b353c3.jpg",
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1735817845/tb-campaign-photos/pronto/assistant_prototype/17adca8fb4ef052fa201d09310b353c3.jpg",
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1735817845/tb-campaign-photos/pronto/assistant_prototype/17adca8fb4ef052fa201d09310b353c3.jpg",
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1735817845/tb-campaign-photos/pronto/assistant_prototype/17adca8fb4ef052fa201d09310b353c3.jpg",
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1735817845/tb-campaign-photos/pronto/assistant_prototype/17adca8fb4ef052fa201d09310b353c3.jpg"
];

const SliderPreview = ({ assets = FALLBACK_IMAGES, imageSelected, emitNewImageSelection }) => {
  const [imageLoadingStates, setImageLoadingStates] = useState(new Array(assets.length).fill(true));

  const handleImageLoad = (index) => {
    setImageLoadingStates((prevStates) =>
      prevStates.map((state, i) => (i === index ? false : state))
    );
  };

  const handleImageSelection = (newImage) => {
    emitNewImageSelection(newImage);
  };

  return (
    <AssetSlider sliderHeight={80}>
      {assets.map((asset, index) => {
        // We need to do includes because the asset could have cloudinary url or a direct url
        const isImageSelected = imageSelected?.includes(asset);
        const isLoading = imageLoadingStates[index];

        return (
          <Fragment key={index}>
            {isLoading ? (
              <ImageLoaderContainer>
                <PulsatingRing />
              </ImageLoaderContainer>
            ) : (
              <Slide
                onClick={() => handleImageSelection(asset)}
                $isSelected={isImageSelected}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
              >
                <SlideAsset asset={asset} />
              </Slide>
            )}
            <img
              src={asset}
              alt={`Slide ${index + 1}`}
              style={{ display: "none" }}
              onLoad={() => handleImageLoad(index)}
            />
            <video
              src={asset}
              alt={`Slide ${index + 1}`}
              style={{ display: "none" }}
              autoPlay
              muted
              loop
              onLoadedMetadata={() => handleImageLoad(index)}
            />
          </Fragment>
        );
      })}
    </AssetSlider>
  );
};

export default SliderPreview;
